import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Anchor } from './styled';
import logoLight from '../../assets/logo_white.png';
import logoDark from '../../assets/logo_black.png';
const Logo = ({ contrast = false, logo, logoUrl, }) => (React.createElement(Anchor, { href: logoUrl, className: "universal-menu-link" }, logo || (React.createElement(LazyLoadImage, { src: contrast ? logoLight : logoDark, alt: "Bitcoin.com logo", wrapperProps: { style: { minHeight: 20, minWidth: 135 } }, effect: "blur" }))));
export default Logo;
//# sourceMappingURL=Logo.js.map